/**
 * Deep clones provided object.
 * It assumes the object to be cloned has been previously transferred through a postMessage channel,
 * and because of that only handles things which work with the structured clone algorithm.
 * (See https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm)
 * And even within that list, it only handles a subset of the possible types,
 * as the values cloned will be part of the existing MetaOS SDK API surface, which uses a limited set of types.
 * @param source value to be cloned
 */
export var deepCopy = function (source) {
    return deepCopyImpl(source);
};
var deepCopyImpl = function (source) {
    // primitive types first
    if (source === undefined ||
        source === null ||
        typeof source === null ||
        typeof source === 'string' ||
        typeof source === 'boolean' ||
        typeof source === 'number') {
        // the primitive types supported are all immutable, so we can return them as is
        return source;
    }
    // arrays
    if (Array.isArray(source)) {
        // apply deepClone to each element and return a new array with all those cloned values
        return source.map(function (i) { return deepCopyImpl(i); });
    }
    // Date - cloning them as objects turns them into strings, so they need to be special-cased
    if (source instanceof Date) {
        return new Date(source.getTime());
    }
    // objects
    if (typeof source === 'object') {
        var result = {};
        for (var _i = 0, _a = Object.getOwnPropertyNames(source); _i < _a.length; _i++) {
            var prop = _a[_i];
            // clone property by property
            var propValue = source[prop];
            result[prop] = deepCopyImpl(propValue);
        }
        return result;
    }
    throw Error("Provided type '" +
        typeof source +
        "' (" +
        Object.prototype.toString.call(source) +
        ") can't be cloned using deepCopy.");
};
//# sourceMappingURL=deepCopy.js.map